import { TrackingService } from "./tracking_service";
import { TileType } from "./types";

export class BrandSpotlight {
    private readonly trackingService: TrackingService;

    constructor(container: Element) {
        const targetPSR = this.getTargetPSR(container);
        const tileType = this.getTileType(container)
        const brandName = this.getBrandName(container)

        this.trackingService = new TrackingService()

        this.trackLoaded(targetPSR, tileType, brandName);
        this.trackClick(container, targetPSR, tileType, brandName);
        this.registerVisibleTrackObserver(container);
    }

    private trackClick(container: Element, targetPSR: string, tileType: TileType, brandName: string): void {
        const linkEl = container.querySelector<HTMLAnchorElement>('a')
        linkEl?.addEventListener("click", (e: MouseEvent) => {
            if (e.target instanceof Element) {
                this.trackingService.sendClickTrackingEvent(targetPSR, tileType, brandName);
            }
        }, false);
    }

    private trackLoaded(targetPSR: string, tileType: TileType, brandName: string): void {
        this.trackingService.sendInitialLoadedTrackingEvent(targetPSR, tileType, brandName);
    }

    private registerVisibleTrackObserver(container: Element): void {
        /*                                     */
        const observer = new IntersectionObserver((entries) => {
            const intersectingEntries = entries.filter((entry) => entry.isIntersecting);
            if (intersectingEntries.length > 0) {
                this.trackingService.sendVisibleTrackingEvent();
                observer.unobserve(container);
            }
        }, {});

        observer.observe(container);
    }

    private getTileType(container: Element): TileType {
        const tileTypeClass =  container.querySelector("oc-link-v2")!.className ?? "";
        return tileTypeClass === 'promo-pdp-brandspotlight__premium' ? 'premium' : 'regular';
    }

    private getBrandName(container: Element): string {
        return container.getElementsByClassName("promo-pdp-brandspotlight__logo-brandname").item(0)?.textContent ?? "";
    }

    private getTargetPSR(container: Element): string {
        return container.querySelector("oc-link-v2")?.getAttribute('data-target-psr') || "";
    }
}
